import { Vector3, Matrix4, Matrix3, Triangle } from 'three';

const EPSILON$1 = 1e-10;
const _tmp1 = new Vector3();
const _tmp2 = new Vector3();
const _matrix4 = new Matrix4();
const _matrix3 = new Matrix3();
function isTriDegenerated(tri) {
    _tmp1.subVectors(tri.a, tri.b);
    _tmp2.subVectors(tri.a, tri.c);
    _tmp1.cross(_tmp2);
    return _tmp1.x > -EPSILON$1 && _tmp1.x < EPSILON$1 &&
        _tmp1.y > -EPSILON$1 && _tmp1.y < EPSILON$1 &&
        _tmp1.z > -EPSILON$1 && _tmp1.z < EPSILON$1;
}
function orient3D(a, b, c, d) {
    _matrix4.set(a.x, a.y, a.z, 1, b.x, b.y, b.z, 1, c.x, c.y, c.z, 1, d.x, d.y, d.z, 1);
    const det = _matrix4.determinant();
    if (det < -EPSILON$1)
        return -1;
    else if (det > EPSILON$1)
        return 1;
    else
        return 0;
}
function orient2D(a, b, c) {
    _matrix3.set(a.x, a.y, 1, b.x, b.y, 1, c.x, c.y, 1);
    const det = _matrix3.determinant();
    if (det < -EPSILON$1)
        return -1;
    else if (det > EPSILON$1)
        return 1;
    else
        return 0;
}
function permuteTriLeft(tri) {
    const tmp = tri.a;
    tri.a = tri.b;
    tri.b = tri.c;
    tri.c = tmp;
}
function permuteTriRight(tri) {
    const tmp = tri.c;
    tri.c = tri.b;
    tri.b = tri.a;
    tri.a = tmp;
}
function makeTriCounterClockwise(tri) {
    if (orient2D(tri.a, tri.b, tri.c) < 0) {
        const tmp = tri.c;
        tri.c = tri.b;
        tri.b = tmp;
    }
}
function linesIntersect2d(a1, b1, a2, b2, target) {
    const dx1 = (a1.x - b1.x);
    const dx2 = (a2.x - b2.x);
    const dy1 = (a1.y - b1.y);
    const dy2 = (a2.y - b2.y);
    const D = dx1 * dy2 - dx2 * dy1;
    const n1 = a1.x * b1.y - a1.y * b1.x;
    const n2 = a2.x * b2.y - a2.y * b2.x;
    target.set((n1 * dx2 - n2 * dx1) / D, (n1 * dy2 - n2 * dy1) / D, 0);
}

const EPSILON = 1e-10;
const _u$1 = new Vector3();
const _v$1 = new Vector3();
const _n1 = new Vector3();
const _n2 = new Vector3();
const _i1 = new Vector3();
const _i2 = new Vector3();
function crossIntersect(t1, t2, o1a, o1b, o1c, target) {
    const o2a = orient3D(t1.a, t1.b, t1.c, t2.a);
    const o2b = orient3D(t1.a, t1.b, t1.c, t2.b);
    const o2c = orient3D(t1.a, t1.b, t1.c, t2.c);
    if (o2a === o2b && o2a === o2c) {
        return false;
    }
    makeTriAVertexAlone(t1, o1a, o1b, o1c);
    makeTriAVertexAlone(t2, o2a, o2b, o2c);
    makeTriAVertexPositive(t2, t1);
    makeTriAVertexPositive(t1, t2);
    const o1 = orient3D(t1.a, t1.b, t2.a, t2.b);
    const o2 = orient3D(t1.a, t1.c, t2.c, t2.a);
    if (o1 <= 0 && o2 <= 0) {
        if (target) {
            computeLineIntersection(t1, t2, target);
        }
        return true;
    }
    return false;
}
function makeTriAVertexAlone(tri, oa, ob, oc) {
    if (oa === ob) {
        permuteTriRight(tri);
    }
    else if (oa === oc) {
        permuteTriLeft(tri);
    }
    else if (ob !== oc) {
        if (ob > 0) {
            permuteTriLeft(tri);
        }
        else if (oc > 0) {
            permuteTriRight(tri);
        }
    }
}
function makeTriAVertexPositive(tri, other) {
    const o = orient3D(other.a, other.b, other.c, tri.a);
    if (o < 0) {
        const tmp = other.c;
        other.c = other.b;
        other.b = tmp;
    }
}
function intersectPlane(a, b, p, n, target) {
    _u$1.subVectors(b, a);
    _v$1.subVectors(a, p);
    const dot1 = n.dot(_u$1);
    const dot2 = n.dot(_v$1);
    _u$1.multiplyScalar(-dot2 / dot1);
    target.addVectors(a, _u$1);
}
function computeLineIntersection(t1, t2, target) {
    t1.getNormal(_n1);
    t2.getNormal(_n2);
    const o1 = orient3D(t1.a, t1.c, t2.b, t2.a);
    const o2 = orient3D(t1.a, t1.b, t2.c, t2.a);
    if (o1 > 0) {
        if (o2 > 0) {
            intersectPlane(t1.a, t1.c, t2.a, _n2, _i1);
            intersectPlane(t2.a, t2.c, t1.a, _n1, _i2);
        }
        else {
            intersectPlane(t1.a, t1.c, t2.a, _n2, _i1);
            intersectPlane(t1.a, t1.b, t2.a, _n2, _i2);
        }
    }
    else {
        if (o2 > 0) {
            intersectPlane(t2.a, t2.b, t1.a, _n1, _i1);
            intersectPlane(t2.a, t2.c, t1.a, _n1, _i2);
        }
        else {
            intersectPlane(t2.a, t2.b, t1.a, _n1, _i1);
            intersectPlane(t1.a, t1.b, t2.a, _n2, _i2);
        }
    }
    target.push(_i1.clone());
    if (_i1.distanceTo(_i2) >= EPSILON) {
        target.push(_i2.clone());
    }
}

const _matrix = new Matrix4();
const _n = new Vector3();
const _u = new Vector3();
const _v = new Vector3();
const _affineMatrix = new Matrix4().set(0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1);
function coplanarIntersect(t1, t2, target) {
    t1.getNormal(_n);
    _u.subVectors(t1.a, t1.b).normalize();
    _v.crossVectors(_n, _u);
    _u.add(t1.a);
    _v.add(t1.a);
    _n.add(t1.a);
    _matrix.set(t1.a.x, _u.x, _v.x, _n.x, t1.a.y, _u.y, _v.y, _n.y, t1.a.z, _u.z, _v.z, _n.z, 1, 1, 1, 1);
    _matrix.invert();
    _matrix.premultiply(_affineMatrix);
    t1.a.applyMatrix4(_matrix);
    t1.b.applyMatrix4(_matrix);
    t1.c.applyMatrix4(_matrix);
    t2.a.applyMatrix4(_matrix);
    t2.b.applyMatrix4(_matrix);
    t2.c.applyMatrix4(_matrix);
    makeTriCounterClockwise(t1);
    makeTriCounterClockwise(t2);
    const p1 = t1.a;
    const p2 = t2.a;
    const q2 = t2.b;
    const r2 = t2.c;
    const o_p2q2 = orient2D(p2, q2, p1);
    const o_q2r2 = orient2D(q2, r2, p1);
    const o_r2p2 = orient2D(r2, p2, p1);
    let intersecting = false;
    if (o_p2q2 >= 0) {
        if (o_q2r2 >= 0) {
            if (o_r2p2 >= 0) {
                intersecting = true;
            }
            else {
                intersecting = intersectionTypeR1(t1, t2);
            }
        }
        else {
            if (o_r2p2 >= 0) {
                permuteTriRight(t2);
                intersecting = intersectionTypeR1(t1, t2);
            }
            else {
                intersecting = intersectionTypeR2(t1, t2);
            }
        }
    }
    else {
        if (o_q2r2 >= 0) {
            if (o_r2p2 >= 0) {
                permuteTriLeft(t2);
                intersecting = intersectionTypeR1(t1, t2);
            }
            else {
                permuteTriLeft(t2);
                intersecting = intersectionTypeR2(t1, t2);
            }
        }
        else {
            if (o_r2p2 >= 0) {
                permuteTriRight(t2);
                intersecting = intersectionTypeR2(t1, t2);
            }
            else {
                console.error("Triangles should not be flat.", t1, t2, _v);
                return false;
            }
        }
    }
    if (intersecting && target) {
        clipTriangle(t1, t2, target);
        _matrix.invert();
        for (const p of target) {
            p.applyMatrix4(_matrix);
        }
    }
    return intersecting;
}
function intersectionTypeR1(t1, t2) {
    const p1 = t1.a;
    const q1 = t1.b;
    const r1 = t1.c;
    const p2 = t2.a;
    const r2 = t2.c;
    if (orient2D(r2, p2, q1) >= 0) {
        if (orient2D(r2, p1, q1) >= 0) {
            if (orient2D(p1, p2, q1) >= 0) {
                return true;
            }
            else {
                if (orient2D(p1, p2, r1) >= 0) {
                    if (orient2D(q1, r1, p2) >= 0) {
                        return true;
                    }
                }
            }
        }
    }
    else {
        if (orient2D(r2, p2, r1) >= 0) {
            if (orient2D(q1, r1, r2) >= 0) {
                if (orient2D(p1, p2, r1) >= 0) {
                    return true;
                }
            }
        }
    }
    return false;
}
function intersectionTypeR2(t1, t2) {
    const p1 = t1.a;
    const q1 = t1.b;
    const r1 = t1.c;
    const p2 = t2.a;
    const q2 = t2.b;
    const r2 = t2.c;
    if (orient2D(r2, p2, q1) >= 0) {
        if (orient2D(q2, r2, q1) >= 0) {
            if (orient2D(p1, p2, q1) >= 0) {
                if (orient2D(p1, q2, q1) <= 0) {
                    return true;
                }
            }
            else {
                if (orient2D(p1, p2, r1) >= 0) {
                    if (orient2D(r2, p2, r1) <= 0) {
                        return true;
                    }
                }
            }
        }
        else {
            if (orient2D(p1, q2, q1) <= 0) {
                if (orient2D(q2, r2, r1) >= 0) {
                    if (orient2D(q1, r1, q2) >= 0) {
                        return true;
                    }
                }
            }
        }
    }
    else {
        if (orient2D(r2, p2, r1) >= 0) {
            if (orient2D(q1, r1, r2) >= 0) {
                if (orient2D(r1, p1, p2) >= 0) {
                    return true;
                }
            }
            else {
                if (orient2D(q1, r1, q2) >= 0) {
                    if (orient2D(q2, r2, r1) >= 0) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}
const _tmp = new Vector3();
const _clip = new Array(3).fill(_tmp);
const _output = new Array();
const _inter = new Vector3();
const _orients = new Array(9).fill(0);
function clipTriangle(t1, t2, target) {
    _clip[0] = t1.a;
    _clip[1] = t1.b;
    _clip[2] = t1.c;
    _output.splice(0, _output.length);
    _output.push(t2.a);
    _output.push(t2.b);
    _output.push(t2.c);
    for (let i = 0; i < 3; i++) {
        const input = [..._output];
        _output.splice(0, _output.length);
        const i_prev = (i + 2) % 3;
        for (let j = 0; j < input.length; j++) {
            _orients[j] = orient2D(_clip[i_prev], _clip[i], input[j]);
        }
        for (let j = 0; j < input.length; j++) {
            const j_prev = (j - 1 + input.length) % input.length;
            if (_orients[j] >= 0) {
                if (_orients[j_prev] < 0) {
                    linesIntersect2d(_clip[i_prev], _clip[i], input[j_prev], input[j], _inter);
                    _output.push(_inter.clone());
                }
                _output.push(input[j].clone());
            }
            else if (_orients[j_prev] >= 0) {
                linesIntersect2d(_clip[i_prev], _clip[i], input[j_prev], input[j], _inter);
                _output.push(_inter.clone());
            }
        }
    }
    for (const point of _output) {
        let j = 0;
        let sameFound = false;
        while (!sameFound && j < target.length) {
            sameFound = point.distanceTo(target[j]) <= 1e-10;
            j++;
        }
        if (!sameFound) {
            target.push(point);
        }
    }
}

const _t1 = new Triangle();
const _t2 = new Triangle();
var Intersection;
(function (Intersection) {
    Intersection["Cross"] = "Cross";
    Intersection["Coplanar"] = "Coplanar";
})(Intersection || (Intersection = {}));
function trianglesIntersect(t1, t2, target) {
    if (target) {
        target.splice(0, target.length);
    }
    if (isTriDegenerated(t1) || isTriDegenerated(t2)) {
        console.warn("Degenerated triangles provided, skipping.");
        return null;
    }
    _t1.copy(t1);
    _t2.copy(t2);
    t1 = _t1;
    t2 = _t2;
    const o1a = orient3D(t2.a, t2.b, t2.c, t1.a);
    const o1b = orient3D(t2.a, t2.b, t2.c, t1.b);
    const o1c = orient3D(t2.a, t2.b, t2.c, t1.c);
    if (o1a === o1b && o1a === o1c) {
        if (o1a === 0 && coplanarIntersect(t1, t2, target)) {
            return Intersection.Coplanar;
        }
        return null;
    }
    if (crossIntersect(t1, t2, o1a, o1b, o1c, target)) {
        return Intersection.Cross;
    }
    return null;
}

export { Intersection, trianglesIntersect };
//# sourceMappingURL=index.esm.js.map
